import { SelectOption } from '@/types/types';
import { BillStatusEnum } from '@/types/graphql/schemaTypes';
import i18n from '@/plugins/i18n';

// deprecated use statusOptions
function options(translator: any): SelectOption<BillStatusEnum>[] {
  return Object.values(BillStatusEnum)
    .filter((state) => {
      return ['draft', 'published', 'paid'].indexOf(state) !== -1;
    })
    .map((state) => {
      return {
        value: state as BillStatusEnum,
        label: translator(`bill.status.${state}`)
      };
    });
}

export function statusOptions(): SelectOption<string>[] {
  return [
    BillStatusEnum.draft,
    BillStatusEnum.published,
    BillStatusEnum.paid
  ].map((val: BillStatusEnum) => {
    return { value: val, label: i18n.t(`bill.status.${val}`).toString() };
  });
}

export default options;
